import React from 'react';

interface Step {
  number: number;
  title: string;
  description: string;
}

const steps: Step[] = [
  {
    number: 1,
    title: 'Install the Agent',
    description:
      'WordPress plugin, Cloudflare worker, or we host it for you. Pick what fits.',
  },
  {
    number: 2,
    title: 'We Scan and Optimize',
    description:
      'Structured data, schema markup, and llms.txt files injected server-side.',
  },
  {
    number: 3,
    title: 'Continuous Monitoring',
    description:
      'We track what AI sees and adjust everything automatically.',
  },
];

export default function HowItWorks() {
  return (
    <section className="flex flex-col items-center text-center w-full">
      <div className="flex flex-col gap-3 items-center max-w-[640px] px-4 md:px-0">
        <h2 className="font-headline text-[32px] md:text-[40px] leading-[1.2] text-[#1e1c1c]">
          One install. We handle everything.
        </h2>

        <p className="font-body font-medium text-[18px] text-[rgba(30,28,28,0.7)] leading-[1.5]">
          Install ByLLMs and we make your site AI readable. No work from you
          required.
        </p>
      </div>

      {/* Desktop: side by side with dividers */}
      <div className="hidden md:flex gap-8 mt-12 w-full max-w-[960px] items-start">
        {steps.map((step, i) => (
          <React.Fragment key={step.number}>
            {i > 0 && (
              <div className="bg-[rgba(30,28,28,0.1)] h-[200px] w-px shrink-0" />
            )}
            <div className="flex flex-col items-center text-center flex-1 gap-5">
              <div className="bg-[#1e1c1c] text-[#fafafa] rounded-full w-12 h-12 flex items-center justify-center font-body font-semibold text-lg">
                {step.number}
              </div>
              <div className="flex flex-col gap-1">
                <div className="font-body font-medium text-[18px] text-[#1e1c1c]">
                  {step.title}
                </div>
                <p className="font-body font-medium text-[16px] text-[rgba(30,28,28,0.7)] leading-[1.5]">
                  {step.description}
                </p>
              </div>
            </div>
          </React.Fragment>
        ))}
      </div>

      {/* Mobile: horizontal scroll cards */}
      <div className="md:hidden mt-8 w-full overflow-x-auto snap-x snap-mandatory scroll-pl-4 scrollbar-hide">
        <div className="flex gap-4">
          {steps.map((step, i) => (
            <div
              key={step.number}
              className={`snap-start w-[280px] shrink-0 bg-white border border-[rgba(30,28,28,0.08)] rounded p-6 flex flex-col items-center text-center gap-4${i === 0 ? ' ml-4' : ''}`}
            >
              <div className="bg-[#1e1c1c] text-[#fafafa] rounded-full w-12 h-12 flex items-center justify-center font-body font-semibold text-lg">
                {step.number}
              </div>
              <div className="flex flex-col gap-1">
                <div className="font-body font-medium text-[18px] text-[#1e1c1c]">
                  {step.title}
                </div>
                <p className="font-body font-medium text-[15px] text-[rgba(30,28,28,0.7)] leading-[1.5]">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
          <div className="w-1 shrink-0" />
        </div>
      </div>
    </section>
  );
}
